import { Parameter } from "src/app/shared/models/form-model/models/form-controlls.model";
import { Values } from "./Values";
import { Pergola } from "./Pergola";
import { SafeUrl } from "@angular/platform-browser";

export class Control {
    ControlType: string;
    ControlTypeInTinterpreter: string;
    KeyName: string;
    DefaultValue: string;
    TranslateCode: string;
    Akapit: string;
    Size: number;
    DisplayInTablePosition: boolean;
    IsPrint: boolean;
    Width: Number;
    Values: Values[];
    PictureCode: string;
    PictureWidth: Number;
    NotAffectToOtherControls: Number;
    Required: boolean;
    ForegrandColour: string;
    BackgroundColour: string;
    Parameters: Param[];
    OtherParams: Parameter[];
    poprawne:boolean = true; 
    wybrany:Parameter = new Parameter();
    Hidden:boolean;
    ParentParameters:Parameter[] = [];
    public pergola: Pergola = new Pergola(); 
    src: SafeUrl;
    Module: Number = -1;
    Position:Number = -1;
    Step: string;
    wystapil:boolean = false;
    Section	:string;
    Dynamic: boolean;
    Row: string;
    Hide:boolean = false;
    selectedOption:string;
  ValuesMultiColumn: Values[];
    bladKontrolki: boolean = false;
    zmianaTypu: boolean;
    bylPoprawny: boolean;
    licznik: number = 0;
    constructor(control:Control){
      
      if(control.KeyName == "DomyślnySilnik"){
              console.log("nadpisuje", console);
          }
        this.ControlType = control.ControlType;
        // this.licznik = control.licznik;
        this.ControlTypeInTinterpreter = control.ControlTypeInTinterpreter;
        this.KeyName = control.KeyName;
        this.DefaultValue = control.DefaultValue;
        this.TranslateCode = control.TranslateCode;
        this.DisplayInTablePosition = control.DisplayInTablePosition;
        this.IsPrint = control.IsPrint;
        this.Width = control.Width;
        this.Values = control.Values;
        this.PictureCode = control.PictureCode;
        this.PictureWidth = control.PictureWidth;
        this.NotAffectToOtherControls = control.NotAffectToOtherControls;
        this.Required = control.Required;
        this.ForegrandColour = control.ForegrandColour;
        this.BackgroundColour = control.BackgroundColour;
        this.Parameters = control.Parameters;
        this.poprawne = control.poprawne;
        this.Hidden = control.Hidden;
        this.Position = control.Position;
        this.Module = control.Module;
        this.Step = control.Step;
        this.ValuesMultiColumn = control.ValuesMultiColumn;
        this.Section = control.Section;
        this.Dynamic = control.Dynamic;
        this.Row = control.Row;
        this.Akapit = control.Akapit;
        this.Size = control.Size;
        if(this.ControlType == "CheckSelectMultiColumn" || this.ControlType == "SelectMultiColumn"){
             this.Values = control.ValuesMultiColumn;
        }
        // console.log("mod in", this.Module, this.Position);
        // console.log("mod in", this.Module, this.Position);
        
        
    }
    ChangeControlType() {
        if(this.wybrany != null){
          this.selectedOption = this.wybrany.Value;
        }
    }
    InitPergola(){
      
      this.pergola.Init(this);
    }
    InitValuePergola(){
      
      this.pergola.InitValue(this);
    }
  }

  
export class Param {
    Disabled:boolean;
    Key: string;
    Module:number;
    ParametrKinf: number;
    ParametrKindName:string;
    Type:number;
    Value: string;
    IsPrint:boolean;
}